<div class="types-dialog">
  <div class="dialog-header">
    <h3 class="mb-0">Farm Note Types</h3>
    <button mat-button (click)="close()">Done</button>
  </div>

  <!-- Add -->
  <div class="add-row">
    <input class="text-input" [(ngModel)]="newType.name" name="newTypeName" placeholder="New type name" maxlength="50"
      (keydown.enter)="add()">
    <input type="color" class="color-input" [(ngModel)]="newType.color" name="newTypeColor" title="Color">
    <mat-form-field class="icon-field" subscriptSizing="dynamic">
      <mat-label>Icon</mat-label>
      <mat-select [(ngModel)]="newType.icon" name="newTypeIcon">
        <mat-select-trigger>
          <fa-icon [icon]="icon(newType.icon)" class="me-2"></fa-icon>{{labelFor(newType.icon)}}
        </mat-select-trigger>
        <mat-option *ngFor="let i of iconChoices" [value]="i.name">
          <fa-icon [icon]="i.icon" class="me-2"></fa-icon>{{i.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" [disabled]="!newType.name.trim() || saving" (click)="add()">
      <fa-icon [icon]="faPlus" class="me-1"></fa-icon>Add
    </button>
  </div>

  <div class="type-list" [nbSpinner]="loading">
    <div *ngIf="!loading && types.length === 0" class="empty">No note types yet. Add one above.</div>

    <div class="type-row" *ngFor="let t of types" [class.inactive]="!t.isActive">
      <ng-container *ngIf="!t._editing">
        <span class="pill" [style.background]="t.color"><fa-icon [icon]="icon(t.icon)" size="sm"></fa-icon> {{t.name}}</span>
        <span *ngIf="!t.isActive" class="badge-inactive">Inactive</span>
        <span class="spacer"></span>
        <button *ngIf="!t.isActive" mat-button (click)="reactivate(t)">Reactivate</button>
        <ng-container *ngIf="t.isActive">
          <button mat-icon-button matTooltip="Edit" (click)="startEdit(t)"><fa-icon [icon]="faPen" size="sm"></fa-icon></button>
          <button mat-icon-button matTooltip="Remove" (click)="confirmDelete(t)"><fa-icon [icon]="faTrash" size="sm"></fa-icon></button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="t._editing">
        <input class="text-input" [(ngModel)]="t._draft.name" name="editName{{t.id}}" maxlength="50">
        <input type="color" class="color-input" [(ngModel)]="t._draft.color" name="editColor{{t.id}}">
        <mat-form-field class="icon-field" subscriptSizing="dynamic">
          <mat-label>Icon</mat-label>
          <mat-select [(ngModel)]="t._draft.icon" name="editIcon{{t.id}}">
            <mat-select-trigger>
              <fa-icon [icon]="icon(t._draft.icon)" class="me-2"></fa-icon>{{labelFor(t._draft.icon)}}
            </mat-select-trigger>
            <mat-option *ngFor="let i of iconChoices" [value]="i.name">
              <fa-icon [icon]="i.icon" class="me-2"></fa-icon>{{i.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <input type="number" class="sort-input" [(ngModel)]="t._draft.sortOrder" name="editSort{{t.id}}" title="Sort order">
        <button mat-button (click)="cancelEdit(t)">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="!t._draft.name?.trim() || saving" (click)="saveEdit(t)">Save</button>
      </ng-container>
    </div>
  </div>
</div>
